import React from 'react';
import GoogleMapReact from 'google-map-react';
import Geocode from 'react-geocode';
import { MapMarker } from '../GoogleMap/MapMarker';
import i18next from 'i18next';

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY as string; // Google Maps API key

// Координаты Москвы как начальная точка
const moscowLat = 55.7558;
const moscowLng = 37.6173;

interface Location {
    lat: number | null;
    lng: number | null;
}

interface AddressPickerProps {
    lang: string;
    address?: string;
    onChange: (formattedAddress: string, lat: number, lng: number) => void;
}

interface AddressPickerState {
    formattedAddress: string;
    coordinates: Location;
    startLat: number;
    startLng: number;
    zoom: number;
}

export default class AddressPicker extends React.Component<AddressPickerProps, AddressPickerState> {

    state: AddressPickerState = {
        formattedAddress: '',
        startLat: moscowLat,
        startLng: moscowLng,
        coordinates: {
            lat: null,
            lng: null
        },
        zoom: 11
    };

    async componentDidMount() {
        // Настройка геокодера: API ключ и язык вывода адреса
        Geocode.setApiKey(API_KEY);
        Geocode.setLanguage(this.props.lang);
        Geocode.setRegion('ru');

        const success = (position: any) => {
            const latitude  = position.coords.latitude;
            const longitude = position.coords.longitude;

            this.setState({
                startLat: latitude,
                startLng: longitude
            });
        };

        const error = () => {
            console.warn('Geolocation permission was denied.');
        };

        navigator.geolocation.getCurrentPosition(success, error);

        if (this.props.address) {
            const response = await Geocode.fromAddress(this.props.address);

            const lat = response.results[0].geometry.location.lat;
            const lng = response.results[0].geometry.location.lng;

            this.setState({
                formattedAddress: this.props.address,
                startLat: lat,
                startLng: lng,
                coordinates: { lat, lng },
                zoom: 14
            });
        }
    }

    render() {
        const { coordinates, formattedAddress, startLat, startLng, zoom } = this.state;
        const { onChange } = this.props;

        return (
            <div>
                <div style={{ width: '100%', height: '84vh' }}>
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: API_KEY }}
                        defaultCenter={{ lat: startLat, lng: startLng }}
                        center={{ lat: coordinates.lat ? coordinates.lat : startLat, lng: coordinates.lng ? coordinates.lng : startLng }}
                        defaultZoom={11}
                        zoom={zoom}
                        onClick={async (e) => {
                            const response = await Geocode.fromLatLng(String(e.lat), String(e.lng));
                            this.setState({
                                formattedAddress: response.results[0].formatted_address,
                                coordinates: {
                                    lat: e.lat,
                                    lng: e.lng
                                }
                            });
                        }}
                    >
                        {coordinates.lat && coordinates.lng && <MapMarker
                            lat={coordinates.lat}
                            lng={coordinates.lng}
                        />}
                    </GoogleMapReact>
                </div>
                <div
                    className='button__wrapper'
                    onClick={() => {
                        if (coordinates.lat && coordinates.lng) {
                            onChange(formattedAddress, coordinates.lat, coordinates.lng);
                        }
                    }}
                >
                    <div className={'button blue center' + (coordinates.lat && coordinates.lng ? '' : ' gray')}>
                        {i18next.t('pick')}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Shared/Address/AddressPicker.tsx